import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Table from 'Components/Table';
import { Box, Text } from 'Components/Base';

const TextWrapper = styled(Box)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
`;

const IndividualUnitDrawerQuizArchetypesTableStyle = styled(Table)`
  width: 100%;

  & table {
    table-layout: fixed;
    width: 100%;
  }

  & .MuiTableCell-sizeSmall {
    border-right: 1px solid ${({ theme }) => theme.colors.white};
    border-bottom: none;
    padding: 12px 12px;
    &:nth-last-child(1) {
      border-right: none;
    }
  }

  & .MuiTableRow-head:nth-child(1) {
    & .MuiTableCell-head {
      &:nth-child(n + 1) {
        border-bottom: 1px solid ${({ theme }) => theme.colors.white};
      }
    }
  }
`;

const TableHead = props => <Text.Hint fontWeight={500} {...props} />;
const HeaderColSpanText = styled(TableHead)`
  /* border-bottom: 1px solid ${({ theme }) => theme.colors.white}; */
  white-space: nowrap;
`;

export const IndividualUnitDrawerQuizArchetypesTable = ({ data, maxHeight, ...props }) => {
  const { t } = useTranslation('individualUnit');

  const columns = [
    {
      id: 'quizArchetypes',
      Header: <HeaderColSpanText>{t('QUIZ_ARCHETYPES')}</HeaderColSpanText>,
      columns: [
        {
          id: 'a1',
          Header: <TableHead>{t('QUIZ_ARCHETYPES_A1')}</TableHead>,
          accessor: 'A1',
          Cell: ({ cell: { value } }) => {
            const { score, total } = value;
            return <TextWrapper>{total > 0 ? `${score}/${total}` : ''}</TextWrapper>;
          },
        },
        {
          id: 'a3',
          Header: <TableHead>{t('QUIZ_ARCHETYPES_A3')}</TableHead>,
          accessor: 'A3',
          Cell: ({ cell: { value } }) => {
            const { score, total } = value;
            return <TextWrapper>{total > 0 ? `${score}/${total}` : ''}</TextWrapper>;
          },
        },
        {
          id: 'a5',
          Header: <TableHead>{t('QUIZ_ARCHETYPES_A5')}</TableHead>,
          accessor: 'A5',
          Cell: ({ cell: { value } }) => {
            const { score, total } = value;
            return <TextWrapper>{total > 0 ? `${score}/${total}` : ''}</TextWrapper>;
          },
        },
        {
          id: 'a9',
          Header: <TableHead>{t('QUIZ_ARCHETYPES_A9')}</TableHead>,
          accessor: 'A9',
          Cell: ({ cell: { value } }) => {
            const { score, total } = value;
            return <TextWrapper>{total > 0 ? `${score}/${total}` : ''}</TextWrapper>;
          },
        },
      ],
    },
  ];

  return (
    <IndividualUnitDrawerQuizArchetypesTableStyle
      dense
      stickyHeader
      columns={columns}
      data={data}
      style={{ maxHeight }}
      {...props}
    />
  );
};

IndividualUnitDrawerQuizArchetypesTable.propTypes = {
  data: PropTypes.array.isRequired,
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default IndividualUnitDrawerQuizArchetypesTable;
